export default "__VITE_ASSET__CPZZI714__"